import { cooldownDeviceBody } from '@planuze/admin-contracts';
import { Input, Label, toast } from '@planuze/ui';
import { useState } from 'react';
import { useUsersContent } from '../../../content/sections/users.js';
import { useCooldownDevice } from '../../../hooks/use-users.js';
import { ReasonDialog } from '../../reason-dialog.js';
import { userErrorMessage } from '../user-error.js';

interface Props {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly userId: string;
  readonly deviceId: string;
}

/* Soft-block de device por N horas (1–720). Bound validado pelo schema do contrato
   (sem literal duplicado na lógica). */
export function CooldownDeviceModal({ open, onClose, userId, deviceId }: Props) {
  const copy = useUsersContent();
  const [hours, setHours] = useState(24);
  const cooldown = useCooldownDevice(userId);
  const confirm = (reason: string): void => {
    cooldown.mutate(
      { deviceId, durationHours: hours, reason },
      {
        onSuccess: () => {
          toast.success(copy.cooldownModal.success);
          onClose();
        },
        onError: (err) => {
          toast.error(userErrorMessage(err, copy.errors));
        },
      },
    );
  };
  return (
    <ReasonDialog
      open={open}
      onClose={onClose}
      title={copy.cooldownModal.title}
      description={copy.cooldownModal.description(deviceId.slice(0, 12))}
      confirmLabel={copy.cooldownModal.confirmLabel}
      reasonLabel={copy.cooldownModal.reasonLabel}
      destructive
      pending={cooldown.isPending}
      validate={(reason) => cooldownDeviceBody.safeParse({ durationHours: hours, reason }).success}
      onConfirm={confirm}
    >
      <div className="space-y-1.5">
        <Label htmlFor="cooldown-hours">{copy.cooldownModal.hoursLabel}</Label>
        <Input
          id="cooldown-hours"
          type="number"
          min={1}
          max={720}
          value={hours}
          onChange={(e) => setHours(Number(e.target.value))}
        />
      </div>
    </ReasonDialog>
  );
}
